<template>
    <v-tooltip right z-index="9999999999" :max-width="width">
        <template v-slot:activator="{ on }">
            <button style="position: relative; top: 4px;" v-on="on">
                <icon
                    name="alert-circle"
                    :size="18"
                    v-bind:style="{ color: $vuetify.theme.themes.light.primary1 }"
                />
            </button>
        </template>
        <span> {{text}} </span>
    </v-tooltip>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: false
    },
    width: {
      type: String,
      required: true,
    }
  }
}
</script>
